<template>
    <div class="container edit-show-header" :class="show.isValid ? '' : 'error'">
            <base-show-image
                :show="show"
                :has-border="true"
                size="medium"
            />
            <div class="wrapper">
                <p class="title">
                    {{ show.isValid ? show.title : 'Unknown' }}
                </p>
                <template v-if="show.isValid">
                    <div class="info">
                        <show-label :item="show" />
                    </div>
                </template>
                <template v-else>
                    <div class="error">
                        <i class="fa fa-exclamation error-icon" />
                        <p class="error-message">
                            Can't read RSS
                        </p>
                    </div>
                </template>
            </div>
        <edit-show-nav
            :show="show"
        />
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import EditShowNav from './EditShowNav';
import ShowLabel from './ShowLabel';

export default {
    components: {
        EditShowNav,
        ShowLabel,
    },

    props: {
        show: {
            type: Object,
            default: () => ({}),
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),
    },
};
</script>
